import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import {
  ClothingRequest,
  EmployeeClothingEntitlementsSource,
  EmployeeClothingOverview,
  EmployeeClothingPosition,
  HeadClothingManualExtensionPayload,
  StorekeeperIssuePayload,
  StorekeeperRejectNoStockPayload
} from '../../../models/clothing.model';
import { ProfileClothingViewItem } from '../../../models/profile-clothing.model';
import { ClothingService } from '../../../services/clothing.service';
import { ProfileClothingViewService } from '../../../services/profile-clothing-view.service';
import { UserService } from '../../../services/user.service';
import { ClothesInfo } from './view-user-profile.types';

@Injectable()
export class ViewUserProfileClothingGateway {
  constructor(
    private clothingService: ClothingService,
    private viewService: ProfileClothingViewService,
    private userService: UserService
  ) {}

  legacyClothes(userId: string): Observable<HttpResponse<ClothesInfo>> {
    return <Observable<HttpResponse<ClothesInfo>>><Object>this.userService.getClothes(userId);
  }

  overview(userId: string, isAdmin: boolean): Observable<EmployeeClothingOverview> {
    return isAdmin
      ? this.clothingService.getAdminEmployeeOverview(userId)
      : this.clothingService.getStorekeeperEmployeeOverview(userId);
  }

  entitlements(userId: string, isAdmin: boolean): Observable<EmployeeClothingEntitlementsSource> {
    return isAdmin
      ? this.clothingService.getAdminEmployeeEntitlements(userId)
      : this.clothingService.getStorekeeperEmployeeEntitlements(userId);
  }

  headPositions(userId: string): Observable<EmployeeClothingPosition[]> {
    return <Observable<EmployeeClothingPosition[]>><Object>this.clothingService.getHeadEmployeePositions(userId);
  }

  storekeeperItems(
    overview: EmployeeClothingOverview,
    entitlements: EmployeeClothingEntitlementsSource
  ): ProfileClothingViewItem[] {
    return this.viewService.mapStorekeeperOverview(overview, entitlements);
  }

  headItems(positions: EmployeeClothingPosition[]): ProfileClothingViewItem[] {
    return this.viewService.mapHeadPositions(positions);
  }

  reject(requestId: string, payload: StorekeeperRejectNoStockPayload): Observable<ClothingRequest> {
    return this.clothingService.rejectStorekeeperRequest(requestId, payload);
  }

  issueRequest(requestId: string, payload: StorekeeperIssuePayload): Observable<ClothingRequest> {
    return this.clothingService.issueStorekeeperRequest(requestId, payload);
  }

  issueStorekeeper(
    userId: string,
    catalogItemId: string,
    payload: StorekeeperIssuePayload
  ): Observable<Object> {
    return this.clothingService.directIssueStorekeeperItem(userId, catalogItemId, payload);
  }

  issueAdmin(
    userId: string,
    catalogItemId: string,
    payload: StorekeeperIssuePayload
  ): Observable<Object> {
    return this.clothingService.directIssueAdminItem(userId, catalogItemId, payload);
  }

  extend(positionId: string, payload: HeadClothingManualExtensionPayload): Observable<Object> {
    return this.clothingService.extendHeadPosition(positionId, payload);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-user-profile/view-user-profile-clothing.gateway.ts